import { track } from "tracking/client";
import { trackClick } from "tracking/hooks/useSegment";
import type { Maybe, TrackingClicked } from "@shared/graphql.types";
import { mapGraphqlToSegmentTrackEvent } from "./mapGraphqlToSegmentEvent";

type TrackClickedOptions = {
  isRedirectAction?: boolean;
};

export const trackClicked = (
  clickedTracking: Maybe<TrackingClicked[]> | undefined,
  { isRedirectAction = false }: TrackClickedOptions = {}
) => {
  clickedTracking?.forEach((data) => {
    const trackingEvent = mapGraphqlToSegmentTrackEvent(data);
    if (trackingEvent) {
      if (isRedirectAction) trackClick(trackingEvent);
      else track(trackingEvent);
    }
  });
};
